/**
 * 本文件由 scripts/genLocaleResourceHash.js 脚本动态生成，请勿手动修改。
 * 供语言包运行时请求与 CI 上传脚本解析 OSS 路径版本号。
 */
export const LOCALE_RESOURCE_HASH = '8db5e5f1' as const;
